// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c73e1e43","498":"010f6751","703":"e87620f6","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};